<template>
  <div class="week-view">
    <!-- Header -->
    <div class="week-header">
      <div class="week-header-hour">
        Hora
      </div>
      <div
        v-for="day in weekViewDays"
        :key="day.dateKey"
        class="week-header-day"
        :class="{ today: day.isToday }"
      >
        <div class="day-name">
          {{ day.weekDay }}
        </div>
        <div
          class="day-number"
          :class="{ 'today-number': day.isToday }"
        >
          {{ day.date }}
        </div>
      </div>
    </div>

    <!-- Time Grid -->
    <div
      ref="timeGrid"
      class="time-grid"
    >
      <div
        v-for="hour in hours"
        :key="hour"
        class="time-row"
      >
        <div class="time-label">
          {{ formatHour(hour) }}
        </div>
        <div
          v-for="day in weekViewDays"
          :key="`${day.dateKey}-${hour}`"
          class="time-cell"
          :class="{ 'today-cell': day.isToday }"
          @click="$emit('timeSlotClick', day, hour)"
        >
          <div class="cell-events">
            <div
              v-for="event in getEventsForHour(day, hour).slice(0, 2)"
              :key="event.id"
              class="event-chip"
              :style="{ backgroundColor: getStatusColor(event.status) }"
              @click.stop="$emit('eventClick', event)"
            >
              {{ event.cliente_id }} {{ formatCliente(event.cliente) || event.observacoes }}
            </div>
            <div
              v-if="getEventsForHour(day, hour).length > 2"
              class="more-link"
              @click.stop="$emit('openDayView', day)"
            >
              +{{ getEventsForHour(day, hour).length - 2 }} mais
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatusColor, formatCliente, formatHour, hours } from '../calendar-utils'

export default {
  name: 'CalendarWeekView',
  props: {
    weekViewDays: { type: Array, required: true },
    getEventsForHour: { type: Function, required: true },
  },
  data() {
    return { hours }
  },
  mounted() {
    this.scrollToHour(8)
  },
  methods: {
    getStatusColor,
    formatCliente,
    formatHour,
    scrollToHour(hour) {
      this.$nextTick(() => {
        const grid = this.$refs.timeGrid
        if (grid && grid.children[hour]) {
          grid.scrollTop = grid.children[hour].offsetTop - grid.offsetTop
        }
      })
    },
  },
}
</script>

<style scoped>
.week-view {
  background: #fff;
  min-height: 500px;
}

.week-header {
  display: grid;
  grid-template-columns: 64px repeat(7, 1fr);
  border-bottom: 1px solid #dadce0;
  background: #fff;
}

.week-header-hour {
  padding: 12px;
  text-align: center;
  font-size: 11px;
  font-weight: 500;
  color: #70757a;
  border-right: 1px solid #dadce0;
}

.week-header-day {
  padding: 12px;
  text-align: center;
  border-right: 1px solid #dadce0;
}

.week-header-day:last-child {
  border-right: 0;
}

.week-header-day.today {
  background: #e8f0fe;
}

.day-name {
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #70757a;
}

.day-number {
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 18px;
  color: #3c4043;
}

.day-number.today-number {
  background: #1a73e8;
  color: #fff;
}

.time-grid {
  max-height: 600px;
  overflow-y: auto;
  background: #fff;
}

.time-row {
  display: grid;
  grid-template-columns: 64px repeat(7, 1fr);
  border-bottom: 1px solid #dadce0;
}

.time-label {
  padding: 12px;
  text-align: right;
  font-size: 11px;
  color: #70757a;
  border-right: 1px solid #dadce0;
}

.time-cell {
  min-height: 48px;
  cursor: pointer;
  border-right: 1px solid #dadce0;
  padding: 4px;
}

.time-cell:last-child {
  border-right: 0;
}

.time-cell:hover {
  background: #f8fafd;
}

.time-cell.today-cell {
  background: #f8fafd;
}

.cell-events {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.event-chip {
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: filter 0.15s;
}

.event-chip:hover {
  filter: brightness(0.95);
}

.more-link {
  cursor: pointer;
  padding: 0 2px;
  font-size: 11px;
  font-weight: 500;
  color: #1a73e8;
}

.more-link:hover {
  text-decoration: underline;
}
</style>
